export default __webpack_public_path__ + "static/media/climate_change.05451013.png";